
<app-main-table [tableConfig]="tableConfig" class="status-family-table"></app-main-table>
